import { useMutation, useQueryClient } from '@tanstack/react-query'
import { ReallocationSource } from '../../../types/reallocation/Reallocation'
import { createReallocation } from '../service/reallocationService'
import { useContextParameters } from '../../../services/api/hooks/useContextParameters'
import reallocationQueryKeys from './reallocationQueryKeys'
import invalidateReportQueries from './invalidateReportQueries'

export const useCreateReallocation = () => {
  const { companyId } = useContextParameters()
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (reallocation: ReallocationSource) => {
      if (!companyId) {
        throw new Error('Company ID is required')
      }
      return createReallocation(reallocation, companyId)
    },
    onSuccess: createdItem => {
      queryClient.setQueryData<ReallocationSource[]>(reallocationQueryKeys.list({ companyId }), old => {
        const list = Array.isArray(old) ? old : []
        return [createdItem, ...list]
      })
      invalidateReportQueries(queryClient)
    },
    onError: error => {
      console.error('Failed to create reallocation:', error)
    }
  })
}
